import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { ownerNav } from '@/lib/navConfig';
import LeaderboardView from '@/components/leaderboard/LeaderboardView';

export default function OwnerLeaderboard() {
  return (
    <AppShell nav={ownerNav} title="Leaderboard Sales" showBell>
      <LeaderboardView />
    </AppShell>
  );
}
